import { render, staticRenderFns } from "./Sheet.vue?vue&type=template&id=2efafed2&scoped=true&"
import script from "./Sheet.vue?vue&type=script&lang=js&"
export * from "./Sheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efafed2",
  null
  
)

export default component.exports